import { DateUtility } from '@solcre-org/core-ui';

export class BookingAttachmentModel {
  public files?: File[];

  constructor(
    public id?: any,
    public originalFileName?: string,
    public createdAt?: Date | null,
    public extension?: string,
    public mimeType?: string,
    public fileSize?: string
  ) {}

  public fromJSON(json: any): BookingAttachmentModel {
    if (json) {
      this.id = json.id;
      this.files = json.files;
      this.originalFileName = json.originalFileName;
      this.extension = json.extension;
      this.mimeType = json.mimeType;
      this.fileSize = json.fileSize;
      this.createdAt = DateUtility.fromUTCtoUruguayDate(json.createdAt);
    }
    return this;
  }

  public static fromJSONList(json: any): BookingAttachmentModel[] {
    if (json) {
      return json.map((element: any) =>
        new BookingAttachmentModel().fromJSON(element)
      );
    }
    return [];
  }

  public toJSON() {
    return {
      id: this.id,
      originalFileName: this.originalFileName,
      extension: this.extension,
      mimeType: this.mimeType,
      fileSize: this.fileSize,
      createdAt: this.createdAt,
      files: this.files,
    };
  }

  public getId() {
    return this.id ?? '';
  }

  public getReference() {
    return this.originalFileName ?? '';
  }
}
